import { useQuery } from "@tanstack/react-query";
import { userApi } from "@bw/shared/api";
import type { PlayerProfileSummaryResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * Where a player plays and their circles, as the server lets this viewer see
 * them (opt-in for others; always for oneself). Missing data degrades to an
 * empty summary in the view, never to invented places.
 */
export function useProfileSummary(userId: string) {
  return useQuery<PlayerProfileSummaryResponse>({
    queryKey: queryKeys.compete.profileSummary(userId),
    queryFn: () => userApi.getProfileSummary(userId),
    enabled: Boolean(userId),
    retry: false,
  });
}
